<script setup>
import {computed, watch} from 'vue';
import {Disclosure, DisclosurePanel} from "@headlessui/vue";
import Navigation from "./Navigation";
import MobileMenuButton from "./MobileMenuButton";
import UserProfile from "./UserProfile";
import LanguageMenu from "./LanguageMenu";
import MobileMenu from "./MobileMenu";
import Logo from "./Logo.vue";
import {useBaseStore} from '@/stores/BaseStore';
import {useRoute} from "vue-router";

const store = useBaseStore();
const route = useRoute();

const baseNavigation = [
    {name: "nav__my_learning_portal", href: "/", current: true, external: false},
    {name: "nav__content_library", href: "/library", current: false, external: false},
];

const updatedNavigation = computed(() => {
    const navigation = [...baseNavigation];

    if (store.currentUser && store.currentUser.admin_url) {
        navigation.push({
            name: "nav__admin_portal",
            href: store.currentUser.admin_url,
            current: false,
            external: true
        });
    }

    return navigation.map(item => {
        return {...item, current: item.href === route.path};
    });
});

// Watch for changes in currentUser to update the navigation
watch(() => store.currentUser, (newVal, oldVal) => {
}, {deep: true, immediate: true});

</script>

<template>
    <Disclosure as="header" class="bg-white shadow" v-if="store.authenticated">
        <template v-slot="{ open }">
            <div class="max-w-7xl mx-auto px-2 py-1 sm:px-4 lg:divide-y lg:divide-gray-200 lg:px-8">
                <div class="relative h-20 flex justify-between">
                    <div class="relative z-10 px-2 flex lg:px-0">
                        <div class="flex-shrink-0 flex items-center">
                            <Navigation :navigation="updatedNavigation"/>
                        </div>
                    </div>
                    <Logo :logo="store.currentBrand.logo" :name="store.currentBrand.name"/>
                    <div class="relative z-10 flex items-center lg:hidden">
                        <LanguageMenu/>
                        <MobileMenuButton :open="open"/>
                    </div>
                    <div class="hidden lg:relative lg:z-10 lg:ml-4 lg:flex lg:items-center">
                        <LanguageMenu/>
                        <UserProfile/>
                    </div>
                </div>
            </div>

            <DisclosurePanel as="nav" class="lg:hidden" aria-label="Global">
                <MobileMenu :navigation="updatedNavigation"/>
            </DisclosurePanel>
        </template>
    </Disclosure>
</template>


